import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeDropdownResult, ProjectResult, Result, ResultList, SecurityLevelEnum, StartProjectInput, StartProjectResult } from 'app/models';
import { EmployeeService, ProjectService, StartProjectService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-start-project-list',
  templateUrl: './start-project-list.component.html',
  styleUrls: ['./start-project-list.component.scss']
})
export class StartProjectListComponent implements OnInit {
  public result: Result = new Result();
  public isBusy: boolean;

  public utility = Utility;

  public startProjectResultList: ResultList<StartProjectResult>;

  public titleText: string;
  public submitButtonText: string;

  public customerId: number = 0;

  private idForDelete: number = 0;
  public customerProjectId: number | null = null;
  public assignedEmployeeId: number | null = null;
  public assignedEmployee = new EmployeeDropdownResult();

  public customerProjectIdIsInvalid = false;
  public assignedEmployeeIdIsInvalid = false;

  public token = '';
  public startProjectIdForHistory = 0;

  public startProjectListButton = false;
  public addStartProjectButton = false;
  public deleteStartProjectButton = false;
  public projectCompletionOrOngoingButton = false;

  public projectList = new Array<ProjectResult>();
  public employeeDropdown = new Array<EmployeeDropdownResult>();

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private startProjectService: StartProjectService,
    private modalService: NgbModal,
    private projectService: ProjectService,
    private employeeService: EmployeeService
  ) {
    this.isBusy = false;
    this.titleText = 'AddStartProject';
    this.submitButtonText = 'Add';

    this.result = new Result();
    this.token = Utility.getTokenType();
    this.startProjectResultList = new ResultList<StartProjectResult>();
  }

  ngOnInit(): void {
    if (this.token === 'dashboardToken') {
      this.employeeService.checkPermission().then(permissionResult => {
        if (permissionResult.success !== true)
          this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
        else if (Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.StartProjectList) === true ||
          Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.AddStartProject) === true
        ) {
          this.startProjectListButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.StartProjectList) ?? false;
          this.addStartProjectButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.AddStartProject) ?? false;
          this.deleteStartProjectButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.DeleteStartProject) ?? false;
          this.projectCompletionOrOngoingButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.ProjectCompletionOrOngoing) ?? false;

          this.params();
          this.getProjectsWithCustomerId();
          this.loadEmployeeDropdown();
        }
      }).catch(() => {
        this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
      });
    } else {
      this.startProjectListButton = true;
      this.loadData();
    }
  }

  private getProjectsWithCustomerId(): void {
    if (this.customerId !== null) {
      this.projectService.getProjectsWithCustomerId(this.customerId, this.token)
        .then(result => {
          if (result.success === true) {
            this.projectList = result.data;
          } else {
            this.result = result;
          }
        });
    }
  }

  private loadEmployeeDropdown(): void {
    this.employeeService.getEmployeeDropdown()
      .then(result => {
        if (result.success === true) {
          this.employeeDropdown = result.data;
        } else {
          this.result = result;
        }
      });
  }

  private params(): void {
    this.activatedRoute.params.forEach(param => {
      if (param.hasOwnProperty('customerId') === true) {
        this.customerId = +param['customerId'];
      }
    });
    this.loadData();
  }

  public loadData(): void {
    if (this.isBusy === false) {

      this.isBusy = true;
      this.startProjectService.getStartProjects(this.customerId ?? 0, this.token).then(result => {
        if (result.success === true)
          this.startProjectResultList = result;
        else
          this.result = result;
      }).finally(() => {
        this.isBusy = false;
      });

    }
  }

  public kalanzaman(zaman:any): number {
    var date: any = new Date(zaman);
    var date2: any = new Date();
    var aa: any = Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) ) /(1000 * 60 * 60 * 24));
    return -1*aa;
  }

  public submit(): void {
    if (this.validation() === true) {
      this.add();
    }
  }

  private validation(): boolean {
    let isValid = true;
    this.result = new Result();
    this.result.message = '';

    this.resetIsInvalidVariables();

    if (this.assignedEmployeeId === null) {
      isValid = false;
      this.assignedEmployeeIdIsInvalid = true;
    }

    if (this.customerProjectId === null) {
      isValid = false;
      this.customerProjectIdIsInvalid = true;
    }

    // if (isValid === false)
    //   this.result.Success = false;
    return isValid;
  }

  private add(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      const startProjectInput: StartProjectInput = {
        assignedEmployeeId: this.assignedEmployeeId ?? 0,
        customerProjectId: this.customerProjectId ?? 0
      };
      this.startProjectService.addStartProject(startProjectInput).then(
        result => {
          this.isBusy = false;
          this.result = result;
          if (this.result.success === true) {
            this.result.message = Utility.AddOperationMessage;
            this.resetPage();
            this.loadData();
          }
        }).catch(() => {
          this.isBusy = false;
        });
    }
  }

  public resetPage(): void {
    this.customerProjectId = null;
    this.assignedEmployeeId = null;
    this.assignedEmployee = new EmployeeDropdownResult();
    this.titleText = 'AddStartProject';
    this.submitButtonText = 'Add';
  }

  private resetIsInvalidVariables(): void {
    this.customerProjectIdIsInvalid = false;
    this.assignedEmployeeIdIsInvalid = false;
  }

  public openAlertModal(modalDanger: any, id: number): void {
    this.idForDelete = id;
    this.modalService.open(modalDanger, {
      centered: true,
      windowClass: 'modal modal-danger'
    });
  }

  public delete(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.startProjectService.deleteStartProject(this.idForDelete).then(result => {
        this.isBusy = false;
        this.result = result;
        if (result.success === true) {
          this.result.message = Utility.DeleteOperationMessage;
          this.modalService.dismissAll();
          this.loadData();
        }
        else {
          this.modalService.dismissAll();
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public cancel(): void {
    this.resetPage();
  }

  public modalOpenVC(modalVC: any): void {
    this.resetPage();
    this.modalService.open(modalVC, {
      centered: true
    });
  }

  public demonstrateHistory(historyModal: any, id: number): void {
    if (this.isBusy === false) {
      this.startProjectIdForHistory = id;
      this.modalService.open(historyModal, {
        centered: true,
        size: 'lg',
        windowClass: 'modal modal-info'
      });
    }
  }

  public assigned(employeeId: number): void {
    if (employeeId !== 0) {
      this.assignedEmployeeId = employeeId;
      const employee = this.employeeDropdown.filter(r => r.id === employeeId)[0];
      this.assignedEmployee.fullName = employee.fullName;
      this.assignedEmployee.personalPictureFileName = employee.personalPictureFileName;
    }
  }

  public updateIsDone(id: number, isDone: boolean): void {
    if (this.isBusy !== true) {
      this.startProjectService.updateIsDone(id, isDone).then(result => {
        this.isBusy = false;
        this.result = result;
        if (result.success === true) {
          this.result.message = Utility.TransactionCompletedSuccessfully;
          this.loadData();
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }
}
